import * as tslib_1 from "tslib";
import { HtmlView } from '@swim/ui';
var MapView = (function (_super) {
    tslib_1.__extends(MapView, _super);
    function MapView(node) {
        return _super.call(this, node) || this;
    }
    return MapView;
}(HtmlView));
export { MapView };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFwLXZpZXcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJtYXAtdmlldy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLFVBQVUsQ0FBQztBQUdsQztJQUFzQyxtQ0FBUTtJQUM1QyxpQkFBWSxJQUFpQjtlQUMzQixrQkFBTSxJQUFJLENBQUM7SUFDYixDQUFDO0lBS0gsY0FBQztBQUFELENBQUMsQUFSRCxDQUFzQyxRQUFRLEdBUTdDIn0=